<template>
    <div>
        <div v-if="resultCount > 50" class="table-filters-text d-flex justify-center" style="cursor: default">{{ tb('(A mostrar apenas os primeiros 50 resultados)') }}</div>
        <v-chip v-for="(filter, index) in getLimitedItems" :key="getText(filter) + index" @click:close="removeFilter(filter, index)" class="chip-close-icon-red" color="white" text-color="black" close-icon="mdi-close-circle-outline" outlined close small>
            <span style="padding-top: 5px">
                {{ getText(filter).toUpperCase() }}
            </span>
        </v-chip>
    </div>
</template>

<script>
export default {
    props: {
        items: {
            type: Array,
            required: true,
        },

        schema: {
            type: Object,
            required: true,
        },
    },

    computed: {
        getItems() {
            // @Note: We want to hide any aggregators, if they exist.
            return this.items.filter((item) => {
                for (const filter in this.schema) {
                    if (!('dataFieldAggregators' in this.schema[filter])) continue;

                    const aggregators = this.schema[filter].dataFieldAggregators;
                    const key = this.schema[filter].itemText;

                    // This item is an aggregator, don't show it!
                    if (item[key] in aggregators) return false;
                }

                return true;
            });
        },
        getLimitedItems() {
            return this.getItems?.length > 50 ? this.getItems.slice(0, 50) : this.getItems;
        },
        resultCount() {
            return this.getItems?.length ?? 0;
        },
    },

    methods: {
        getText(filter) {
            for (const key in this.schema) {
                const schema = this.schema[key];

                const hasItemInFilters = 'items' in schema && schema.items.includes(filter);
                let localStorageAggregatorIndex=JSON.parse(localStorage.getItem('aggregatorIndex'));
                let index= localStorageAggregatorIndex?localStorageAggregatorIndex:0
                const hasItemInAggregators = 'dataFieldAggregators' in schema && Object.values(schema.dataFieldAggregators).length && Object.values(schema.dataFieldAggregators)[index]?.includes(filter);

                if (hasItemInFilters || hasItemInAggregators) {
                    return filter[schema.itemText];
                }
            }

            throw new Error('Active filters: could not find item in schema.');
        },

        removeFilter(filter, index) {
            this.$emit('remove-filter', index);

            window.EventBus.$emit('removed-active-filter');
        },
    },
};
</script>

<style>
.chip-close-icon-red > .v-chip__content > .v-chip__close {
    color: red;
    margin-left: 3px;
}
</style>
